import {useSelector} from 'react-redux'
import axios from 'axios'
import gif from './loading.gif'
import {useState} from 'react'


let a

function  Speaker(props){
    const [load,setLoad] = useState(false)


    const data = useSelector(state => state.speaker_)
    
    function getData (){
        axios.get(`/?id=WIrbis&action=Conference/GetAuthorInfo&sid=${props.sid}&authorid=${data}`).then((resp) => {
            setLoad(true)
            a = resp.data
       
          
      })
      }








if (load == false) {
    return (<div className='loading'><img onLoad={getData()} src={gif} width='100' height='100'/> </div>)
  }else{
  return(
        
       <div className='link' dangerouslySetInnerHTML={{__html: a} }></div> 
              
          

    )}
}






export default Speaker